import { useState } from "react";
import { Modal } from "react-bootstrap";

export function BlogSubscriptionPopup({ configuration, show, onHide }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });
  const [formDone, setFormDone] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const url = "/api/v1/blog/subscriptions/";
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": OsoigoNext.getCookie("csrftoken"),
        "Accept-Language": window.location.pathname.split("/")[1],
      },
      body: JSON.stringify(formData),
    };

    fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then((data) => {})
      .catch((error) => {})
      .finally(() => {
        setFormDone(true);
      });
  };

  let content = "";
  if (formDone) {
    content = (
      <>
        <p>{configuration.translations.emailSent}</p>
      </>
    );
  } else {
    content = (
      <>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="form-label fw-bold" htmlFor="name">{configuration.translations.nameLabel}</label>
            <input
              id="name"
              className="form-control"
              type="text"
              name="name"
              placeholder={configuration.translations.nameLabel}
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-4">
            <label className="form-label fw-bold" htmlFor="email">{configuration.translations.emailLabel}</label>
            <input
              id="email"
              className="form-control"
              type="email"
              name="email"
              placeholder={configuration.translations.emailLabel}
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-check w-100">
            <input
              className="form-check-input"
              type="checkbox"
              name="share_info"
              required
              id="share_info"
            />
            <label
              htmlFor="share_info"
              className="form-check-label"
              dangerouslySetInnerHTML={{
                __html: configuration.translations.termsText,
              }}
            ></label>
          </div>
          <div className="d-flex justify-content-center align-items-center mt-4">
            <button className="btn btn-primary" type="submit">
              {configuration.translations.subscribeButton}
            </button>
          </div>
        </form>
      </>
    );
  }

  return (
    <Modal show={show} onHide={onHide} className="SuggestionForm">
      <Modal.Header closeButton className="bg-light">
        <Modal.Title>{configuration.translations.blogSubscriptionTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
        <p>{configuration.translations.blogSubscriptionDescr}</p>
        </div>
        <div>
          {content}
        </div>
      </Modal.Body>
    </Modal>
  );
}
